import { createDemoStore } from '@/demo/core/create-demo-store';
import type { MaterialId } from '../../data/types';

interface MaterialsState {
  /** Materials whose renewal term sheet was sent to Legal. */
  termSheetSentFor: MaterialId[];
}

function buildSeed(): MaterialsState {
  return { termSheetSentFor: [] };
}

export const materialsStore = createDemoStore<MaterialsState>(buildSeed);

export function markTermSheetSent(materialId: MaterialId): void {
  materialsStore.update((draft) => {
    if (!draft.termSheetSentFor.includes(materialId)) {
      draft.termSheetSentFor.push(materialId);
    }
  });
}

export function resetMaterialsDemo(): void {
  materialsStore.reset();
}
